import React, { useState, useEffect } from 'react';
import Logo from './Logo';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const goHome = () => {
    if (window.location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/';
    }
    setIsMobileMenuOpen(false);
  };

  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check for Apple devices (iOS and macOS)
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.open('https://apps.apple.com/in/app/scan2card/id6752845236', '_blank');
      return;
    }

    if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
      window.open('https://apps.apple.com/in/app/scan2card/id6752845236', '_blank');
      return;
    }

    // For Android and all other devices, open Play Store
    window.open('https://play.google.com/store/apps/details?id=com.scan2card.quickleads', '_blank');
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div
          className="nav-brand"
          onClick={goHome}
          style={{ cursor: 'pointer' }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              goHome();
            }
          }}
          aria-label="Go to home page"
        >
          <Logo variant="light" size="medium" />
        </div>
        
        <div className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
          <button onClick={() => scrollToSection('features')} className="nav-link">
            Features
          </button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">
            Contact
          </button>
          <a
            href="https://dashboard.scan2card.com/login"
            target="_blank"
            rel="noopener noreferrer"
            className="dashboard-button"
          >
            Dashboard Login
          </a>
          <button onClick={handleDownloadClick} className="cta-button">
            Download App
          </button>
        </div>

        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;